import { render } from "./EventCard.vue?vue&type=template&id=9e86f76e&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=9e86f76e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e86f76e"

export default script